import React from 'react';
import './adminUi.css';

export function AdminPageHeader(props: {
    eyebrow?: string;
    title: string;
    description?: React.ReactNode;
    actions?: React.ReactNode;
}) {
    return (
        <section className="adminPageHeader">
            <div>
                {props.eyebrow ? <div className="adminPageEyebrow">{props.eyebrow}</div> : null}
                <h1 className="adminPageTitle">{props.title}</h1>
                {props.description ? <div className="adminPageDescription">{props.description}</div> : null}
            </div>

            {props.actions ? <div className="adminPageActions">{props.actions}</div> : null}
        </section>
    );
}